import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './layouts/App/App';
import reportWebVitals from './utils/reportWebVitals';
import { sendToVercelAnalytics } from './utils/vitals';
import { initMCP } from './mcp';

// Initialize MCP for Cursor AI
initMCP();

// Create root for React 18+
const container = document.getElementById('root');
const root = createRoot(container);

// Render the App component
root.render(
  // NOTE: <React.StrictMode> is temporarily commented out.
  // In development, Strict Mode double-invokes effects, which was causing
  // `supabase.auth.getSession()` in AuthContext to hang indefinitely.
  // This issue does NOT affect production builds. Re-enable if the
  // underlying issue in Supabase client or React is resolved.
  // React.createElement(React.StrictMode, null,
    React.createElement(App, null)
  // )
);

reportWebVitals(sendToVercelAnalytics);
